export const data = {


    scene: '03_sauvat_sopivat',
    kysymysteksti: 'Hienoa, sauvat säädetty oikealle korkeudelle',

    optiot: []


};